
import { defineComponent, onMounted, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import { GoogleSignInButton, CredentialResponse } from "vue3-google-signin";
import { decodeCredential } from "vue3-google-login";

import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
    GoogleSignInButton,
  },
  methods: {
    /* loginWithGoogle() {
      this.$gapi.login().then(() => {
        const user = this.$gapi.getUserData();
        if (user) {
          this.onSubmitGoogleLogin({ id: user.id, email: user.email });
        }
      });
    }, */
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const submitButton = ref<HTMLButtonElement | null>(null);
    const googleLoginButton = ref<HTMLButtonElement | null>(null);

    //Create form validation object
    const loginValidation = Yup.object().shape({
      username: Yup.string().email().required().label("Username"),
      password: Yup.string().min(4).required().label("Password"),
    });

    onMounted(async () => {
      if (route.query.token) {
        const { token } = route.query;
        // Clear existing errors
        await store.dispatch(Actions.LOGOUT);

        await store.dispatch(Actions.VERIFY_AUTH, { token });
        const error = store.getters.getErrors.message;

        if (!error) {
          Swal.fire({
            text: "You have successfully logged in!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            // Go to page after successfully login
            router.push({ name: "dashboard" });
          });
        } else {
          Swal.fire({
            text: error,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } else if (store.getters.isUserAuthenticated) {
        router.push({ name: "dashboard" });
      }
    });

    //Form submit function
    const onSubmitLogin = async (values) => {
      // Clear existing errors
      await store.dispatch(Actions.LOGOUT);

      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value!.disabled = true;
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      // Send login request
      await store.dispatch(Actions.LOGIN, values);
      const error = store.getters.getErrors.message;

      if (!error) {
        Swal.fire({
          text: "You have successfully logged in!",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Ok, got it!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        }).then(function () {
          // Go to page after successfully login
          router.push({ name: "dashboard" });
        });
      } else {
        Swal.fire({
          text: error,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }

      //Deactivate indicator
      submitButton.value?.removeAttribute("data-kt-indicator");
      // eslint-disable-next-line
      submitButton.value!.disabled = false;
    };

    const handleGoogleLoginSuccess = (response: CredentialResponse) => {
      const { credential } = response;
      if (credential) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const userData: any = decodeCredential(credential);
        onSubmitGoogleLogin({ id: userData.sub, email: userData.email });
      } else {
        Swal.fire({
          text: "Google Login Failed",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
    };

    // handle an error event
    const handleGoogleLoginError = () => {
      Swal.fire({
        text: "Google Login Failed",
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Try again!",
        customClass: {
          confirmButton: "btn fw-bold btn-light-danger",
        },
      });
    };

    const onSubmitGoogleLogin = async (values) => {
      if (googleLoginButton.value) {
        // eslint-disable-next-line
        googleLoginButton.value!.disabled = true;
        // Activate indicator
        googleLoginButton.value.setAttribute("data-kt-indicator", "on");
      }

      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      // Send login request
      await store.dispatch(Actions.GOOGLE_LOGIN, values);
      const error = store.getters.getErrors.message;

      if (!error) {
        Swal.fire({
          text: "You have successfully logged in!",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Ok, got it!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        }).then(function () {
          // Go to page after successfully login
          router.push({ name: "dashboard" });
        });
      } else {
        Swal.fire({
          text: error,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }

      if (googleLoginButton.value) {
        //Deactivate indicator
        googleLoginButton.value?.removeAttribute("data-kt-indicator");
        // eslint-disable-next-line
        googleLoginButton.value!.disabled = false;
      }
    };

    return {
      onSubmitLogin,
      onSubmitGoogleLogin,
      loginValidation,
      submitButton,
      googleLoginButton,
      handleGoogleLoginSuccess,
      handleGoogleLoginError,
    };
  },
});
